import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import { AxiosClient } from './AxiosClient';

export class BaseApiClient {
  private axiosClient: AxiosClient;

  constructor(baseURL: string, defaultHeaders: Record<string, string> = {}) {
    this.axiosClient = new AxiosClient(baseURL, defaultHeaders);
  }

  public async get<T>(
    endpoint: string,
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {}
  ): Promise<AxiosResponse<T>> {
    const client = await this.axiosClient.getClient();

    return client.get<T>(endpoint, { ...config, params });
  }

  public async post<T, D>(
    endpoint: string,
    data: D,
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {}
  ): Promise<AxiosResponse<T>> {
    const client = await this.axiosClient.getClient();

    return client.post<T>(endpoint, data, { ...config, params });
  }

  public async put<T, D>(endpoint: string, data: D, config: AxiosRequestConfig = {}): Promise<AxiosResponse<T>> {
    const client = await this.axiosClient.getClient();

    return client.put<T>(endpoint, data, config);
  }

  public async delete<T>(endpoint: string, config: AxiosRequestConfig = {}): Promise<AxiosResponse<T>> {
    const client = await this.axiosClient.getClient();

    return client.delete<T>(endpoint, config);
  }
}
